
import { Wedding, Guest, Task, Vendor, BudgetItem, ScheduleItem, Ring, CeremonyMeta, CeremonyStep } from '../../types';

interface ContextData {
  wedding: Wedding;
  guests: Guest[];
  tasks: Task[];
  vendors: Vendor[];
  budget: BudgetItem[];
  schedule: ScheduleItem[];
  rings: Ring[];
  ceremonyMeta: CeremonyMeta | null;
  ceremonySteps: CeremonyStep[];
  includeSensitive: boolean;
}

export const buildSystemPrompt = (data: ContextData | null): string => {
  const basePrompt = `Jsi MarryPlan AI, zkušený svatební koordinátor. 
Odpovídej stručně, nápomocně a v českém jazyce (pokud uživatel nezačne anglicky). 
Používej Markdown pro formátování (tučně, odrážky).`;

  if (!data) return basePrompt;

  const { wedding, guests, tasks, vendors, budget, schedule, rings, ceremonyMeta, ceremonySteps, includeSensitive } = data;

  const confirmed = guests.filter(g => g.rsvp_status === 'confirmed').length;
  const pending = guests.filter(g => g.rsvp_status === 'pending').length;
  const totalGuests = guests.length;

  const budgetPlanned = budget.reduce((acc, item) => acc + (item.planned_amount || 0), 0);
  const budgetPaid = budget.reduce((acc, item) => acc + (item.paid_amount || 0), 0);

  const pendingTasks = tasks
    .filter(t => t.status !== 'done')
    .slice(0, 5)
    .map(t => `- ${t.title} (fáze: ${t.phase})`)
    .join('\n');

  const vendorList = vendors
    .map(v => {
      let str = `- ${v.type}: ${v.name} (${v.status})`;
      if (includeSensitive && v.price_estimate) str += `, cena: ${v.price_estimate}`;
      return str;
    })
    .join('\n');
    
  const ringsList = rings.map(r => `- ${r.owner}: ${r.style_name} (${r.material}, ${r.status})`).join('\n');
  const ceremonyInfo = ceremonyMeta ? `- Typ: ${ceremonyMeta.ceremony_type}, Místo: ${ceremonyMeta.location_name}` : 'Není nastaveno';
  const ceremonyTimeline = ceremonySteps.map(s => `${s.order_index}. ${s.step_name}`).join(', ');

  const contextBlock = `
AKTUÁLNÍ KONTEXT SVATBY:
- Svatba: ${wedding.title}, ${new Date(wedding.date).toLocaleDateString()}, ${wedding.location}
- Hosté: ${confirmed} potvrzeno, ${pending} čeká, ${totalGuests} celkem.
- Rozpočet: Naplánováno ${budgetPlanned} Kč, Zaplaceno ${budgetPaid} Kč.
- Nadcházející úkoly:
${pendingTasks || '(žádné)'}
- Dodavatelé:
${vendorList || '(žádní)'}
- Prstýnky:
${ringsList || '(žádné)'}
- Obřad:
${ceremonyInfo}
Průběh: ${ceremonyTimeline}

${!includeSensitive ? 'POZNÁMKA: Citlivé údaje (kontakty, poznámky) byly skryty.' : ''}
`;

  return `${basePrompt}\n\n${contextBlock}`;
};
